import React from 'react';
import { Link } from 'gatsby';
import Text from 'components/Text';
import WistiaVideo from 'components/WistiaVideo';
import { STIcon } from 'components/Brand/Icons/STIcon';
import { TrustBarCardContainer } from './styles';

const TrustBarCard = ({ cardInfo }) => {
  const { description, stats, statCaption, wistiaVideo, ctaLink, ctaText } = cardInfo;

  return (
    <TrustBarCardContainer className="trust-bar--review-wrapper">
      <div className="trust-bar--review-content-container">
        <div className="trust-bar--review-quote-container">
          <Text type="p">“{description.description}”</Text>
        </div>
        <div className="trust-bar--review-revenue-container">
          <div className="trust-bar--review-stats-container">
            <div className="trust-bar--review-stats-percent">
              <p>{stats}</p>
              {(statCaption.includes('Increase') || statCaption.includes('Growth')) && (
                <STIcon type="icon-increase" />
              )}
            </div>
            <p className="trust-bar--review-stats-description">{statCaption}</p>
          </div>
          <div className="trust-bar--review-video-container">
            <WistiaVideo className="section-company-hero--video-button" {...wistiaVideo} />
          </div>
        </div>
      </div>
      {ctaLink && (
        <div className="trust-bar--review-footer-container">
          <Link to={ctaLink}>{ctaText}</Link>
        </div>
      )}
    </TrustBarCardContainer>
  );
};

export default TrustBarCard;
